import React from "react";
import { Box } from "@mui/material";

const ChatAreaMessageThinkingBubble = ({ loading }: { loading: boolean }) => {
  return (
    <>
      {loading && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
          }}
        >
          <span
            style={{
              color: "#d1d5db",
              padding: "2px 2px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "14px",
              letterSpacing: "0.02em",
              boxShadow: "0 1px 4px rgba(37,99,235,0.08)",
              transition: "all 0.2s",
            }}
          >
            Thinking
          </span>
          <Box
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              backgroundColor: "#3b82f6",
              animation: "pulse 1.4s ease-in-out infinite",
              animationDelay: "0s",
              "@keyframes pulse": {
                "0%, 80%, 100%": {
                  opacity: 0.3,
                  transform: "scale(0.8)",
                },
                "40%": {
                  opacity: 1,
                  transform: "scale(1.2)",
                },
              },
            }}
          />
          <Box
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              backgroundColor: "#3b82f6",
              animation: "pulse 1.4s ease-in-out infinite",
              animationDelay: "0.2s",
              "@keyframes pulse": {
                "0%, 80%, 100%": {
                  opacity: 0.3,
                  transform: "scale(0.8)",
                },
                "40%": {
                  opacity: 1,
                  transform: "scale(1.2)",
                },
              },
            }}
          />
          <Box
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              backgroundColor: "#3b82f6",
              animation: "pulse 1.4s ease-in-out infinite",
              animationDelay: "0.4s",
              "@keyframes pulse": {
                "0%, 80%, 100%": {
                  opacity: 0.3,
                  transform: "scale(0.8)",
                },
                "40%": {
                  opacity: 1,
                  transform: "scale(1.2)",
                },
              },
            }}
          />
        </Box>
      )}
    </>
  );
};

export default ChatAreaMessageThinkingBubble;
